import { AddressesAddressDataDto, GetAddressRequirementsResponse } from "@springtree/eva-services-core";
import { z } from "zod";

import { KIKOApplicationConfiguration } from "../../global";

const formUtils = {
  generateSchemaFromRequirements(requirements: GetAddressRequirementsResponse["AddressRequirements"]) {
    let schema = z.object({});

    if (!requirements) return;

    for (const [field, rules] of Object.entries(requirements)) {
      if (rules.Visible === 2) {
        // This field is hidden. Do not validate it.
        continue;
      }

      const validation = z
        .string()
        .min(rules.Visible === 3 ? Math.max(rules.MinLength!, 1) : rules.MinLength!)
        .max(rules.MaxLength || 999);

      if (rules.Visible === 1) {
        // This field is visible but optional.
        schema = schema.extend({ [field]: z.optional(validation) });
      } else if (rules.Visible === 3) {
        // This field is visible and required.
        schema = schema.extend({ [field]: validation });
      } else {
        throw new Error(`Unexpected visibility status ${rules.Visible} for field ${field}`);
      }
    }

    return schema;
  },
  generateFiscalIdSchemaFromOrderRequirements(
    requirements: KIKOApplicationConfiguration["App:Ecommerce:OrderRequirements"] | null
  ) {
    const requirement = requirements?.Customer?.FiscalID;

    if (!requirement || requirement.Visible === 2) {
      return z.object({ FiscalID: z.undefined() });
    }

    let validation = z
      .string()
      .min(requirement.Visible === 3 ? Math.max(requirement.MinLength!, 1) : requirement.MinLength!)
      .max(requirement.MaxLength || 999);

    if (requirement.Validation) {
      validation = validation.regex(new RegExp(requirement.Validation));
    }

    if (requirement.Visible === 1) {
      // This field is visible but optional.
      return z.object({ FiscalID: z.optional(validation).or(z.literal("")) });
    } else if (requirement.Visible === 3) {
      // This field is visible and required.
      return z.object({ FiscalID: validation });
    } else {
      throw new Error(`Unexpected visibility status ${requirement.Visible} for field FiscalID`);
    }
  },
  getHouseNumberEmptyValue(): string {
    return process.env.NEXT_PUBLIC_HOUSE_NUMBER_EMPTY_VALUE || "N/A";
  },
};

export default formUtils;
